<template>
  <div class="px-4 w-full">
    <!-- Header -->
    <BaseCard
      border
      class="rounded-xl w-full bg-white"
    >
      <ModularDetailsSectionHeader
        :expanded="expanded"
        :section="{ type: 'format', title: 'Format' }"
        badge-text="Selected"
        :filled="!!selectedFormat"
        @toggleExpanded="$emit('toggleExpanded')"
        @deleteSection="$emit('deleteSection')"
      />

      <div
        v-if="expanded"
        class="flex flex-wrap gap-2 px-4 py-4"
      >
        <!-- Video -->
        <ModularDetailsToggleOption
          :selected="selectedFormat === 'video'"
          @click="toggleSelectedFormat('video')"
        >
          <svg
            slot="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.75 12H7.75M3.75 12L3.75 7.875M3.75 12L3.75 16.125M7.75 12L16.25 12M7.75 12L7.75 16.125M7.75 12V7.875M16.25 12H20.25M16.25 12V16.5833M16.25 12V7.875M20.25 12V7.875M20.25 12L20.25 16.5833M16.25 20.25H18.25C19.3546 20.25 20.25 19.3546 20.25 18.25V16.5833M16.25 20.25V16.5833M16.25 20.25L7.75 20.25M16.25 3.75H18.25C19.3546 3.75 20.25 4.64543 20.25 5.75V7.875M16.25 3.75V7.875M16.25 3.75L7.75 3.75M16.25 7.875L20.25 7.875M16.25 16.5833H20.25M7.75 20.25H5.75C4.64543 20.25 3.75 19.3546 3.75 18.25L3.75 16.125M7.75 20.25L7.75 16.125M7.75 3.75H5.75C4.64543 3.75 3.75 4.64543 3.75 5.75V7.875M7.75 3.75L7.75 7.875M3.75 7.875L7.75 7.875M3.75 16.125H7.75"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="square"
              stroke-linejoin="round"
            />
          </svg>

          <BaseText
            type="label"
            size="sm"
            class="text-text-muted"
          >
            Video
          </BaseText>
        </ModularDetailsToggleOption>

        <!-- Still Image -->
        <ModularDetailsToggleOption
          :selected="selectedFormat === 'image'"
          @click="toggleSelectedFormat('image')"
        >
          <svg
            slot="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.23598 15.4538C2.93435 15.7377 2.91996 16.2124 3.20385 16.514C3.48774 16.8157 3.96239 16.83 4.26402 16.5462L3.23598 15.4538ZM7.29353 12.6649L7.80756 13.2111H7.80756L7.29353 12.6649ZM8.686 12.686L8.15567 13.2163L8.686 12.686ZM12 16L11.4697 16.5303C11.6103 16.671 11.8011 16.75 12 16.75C12.1989 16.75 12.3897 16.671 12.5303 16.5303L12 16ZM13.2929 14.7071L12.7626 14.1768L12.7626 14.1768L13.2929 14.7071ZM14.7071 14.7071L14.1768 15.2374H14.1768L14.7071 14.7071ZM18.9697 20.0303C19.2626 20.3232 19.7374 20.3232 20.0303 20.0303C20.3232 19.7374 20.3232 19.2626 20.0303 18.9697L18.9697 20.0303ZM5.75 4.5L18.25 4.5V3L5.75 3V4.5ZM19.5 5.75V18.25L21 18.25L21 5.75H19.5ZM18.25 19.5H5.75V21L18.25 21L18.25 19.5ZM4.5 18.25L4.5 5.75H3L3 18.25H4.5ZM5.75 19.5C5.05964 19.5 4.5 18.9404 4.5 18.25H3C3 19.7688 4.23122 21 5.75 21V19.5ZM19.5 18.25C19.5 18.9404 18.9404 19.5 18.25 19.5L18.25 21C19.7688 21 21 19.7688 21 18.25L19.5 18.25ZM18.25 4.5C18.9404 4.5 19.5 5.05964 19.5 5.75H21C21 4.23122 19.7688 3 18.25 3V4.5ZM5.75 3C4.23122 3 3 4.23122 3 5.75H4.5C4.5 5.05964 5.05964 4.5 5.75 4.5V3ZM4.26402 16.5462L7.80756 13.2111L6.77951 12.1188L3.23598 15.4538L4.26402 16.5462ZM8.15567 13.2163L11.4697 16.5303L12.5303 15.4697L9.21633 12.1557L8.15567 13.2163ZM12.5303 16.5303L13.8232 15.2374L12.7626 14.1768L11.4697 15.4697L12.5303 16.5303ZM14.1768 15.2374L18.9697 20.0303L20.0303 18.9697L15.2374 14.1768L14.1768 15.2374ZM13.8232 15.2374C13.9209 15.1398 14.0791 15.1398 14.1768 15.2374L15.2374 14.1768C14.554 13.4934 13.446 13.4934 12.7626 14.1768L13.8232 15.2374ZM7.80756 13.2111C7.90595 13.1185 8.06013 13.1208 8.15567 13.2163L9.21633 12.1557C8.54751 11.4868 7.46828 11.4705 6.77951 12.1188L7.80756 13.2111ZM15 9C15 9.41421 14.6642 9.75 14.25 9.75V11.25C15.4926 11.25 16.5 10.2426 16.5 9H15ZM14.25 9.75C13.8358 9.75 13.5 9.41421 13.5 9L12 9C12 10.2426 13.0074 11.25 14.25 11.25V9.75ZM13.5 9C13.5 8.58579 13.8358 8.25 14.25 8.25V6.75C13.0074 6.75 12 7.75736 12 9L13.5 9ZM14.25 8.25C14.6642 8.25 15 8.58579 15 9H16.5C16.5 7.75736 15.4926 6.75 14.25 6.75V8.25Z"
              fill="currentColor"
            />
          </svg>

          <BaseText
            type="label"
            size="sm"
            class="text-text-muted"
          >
            Still Image
          </BaseText>
        </ModularDetailsToggleOption>

        <!-- Carousel -->
        <ModularDetailsToggleOption
          :selected="selectedFormat === 'carousel'"
          @click="toggleSelectedFormat('carousel')"
        >
          <svg
            slot="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 18V6M7 18C7 19.1046 7.89543 20 9 20H15C16.1046 20 17 19.1046 17 18M7 18H5C3.89543 18 3 17.1046 3 16V8C3 6.89543 3.89543 6 5 6L7 6M17 18V6M17 18H19C20.1046 18 21 17.1046 21 16V8C21 6.89543 20.1046 6 19 6H17M17 6C17 4.89543 16.1046 4 15 4H9C7.89543 4 7 4.89543 7 6"
              stroke="currentColor"
              stroke-width="1.5"
            />
          </svg>

          <BaseText
            type="label"
            size="sm"
            class="text-text-muted"
          >
            Carousel
          </BaseText>
        </ModularDetailsToggleOption>

        <!-- GIF -->
        <ModularDetailsToggleOption
          :selected="selectedFormat === 'gif'"
          @click="toggleSelectedFormat('gif')"
        >
          <svg
            slot="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.75 12.3676C5.75 14.0113 6.70955 15 8.34036 15C9.79045 15 10.7672 14.138 10.7672 12.8662V12.5155C10.7672 11.9789 10.5176 11.738 9.94966 11.738H8.89544C8.51678 11.738 8.31454 11.9113 8.31454 12.2282C8.31454 12.5493 8.52108 12.7268 8.89544 12.7268H9.4247V12.9718C9.4247 13.5 9.01162 13.8549 8.3963 13.8549C7.60456 13.8549 7.16997 13.3268 7.16997 12.3634V11.6662C7.16997 10.6901 7.59596 10.1789 8.40921 10.1789C8.96429 10.1789 9.287 10.5085 9.63554 10.8507C9.76033 10.9732 9.88941 11.0282 10.0572 11.0282C10.3972 11.0282 10.6338 10.8 10.6338 10.4662C10.6338 10.1324 10.3799 9.76901 9.99268 9.49437C9.56239 9.17746 8.97289 9 8.30594 9C6.72246 9 5.75 10.0014 5.75 11.5986V12.3676Z"
              fill="currentColor"
            />
            <path
              d="M12.3894 14.9155C12.8412 14.9155 13.0951 14.6451 13.0951 14.1634V9.81549C13.0951 9.33803 12.8369 9.06338 12.3808 9.06338C11.9247 9.06338 11.6708 9.3338 11.6708 9.81549V14.1634C11.6708 14.6408 11.9333 14.9155 12.3894 14.9155Z"
              fill="currentColor"
            />
            <path
              d="M14.9626 14.9155C15.4101 14.9155 15.6596 14.6451 15.6596 14.1634V12.7014H17.4669C17.8025 12.7014 18.0306 12.4817 18.0306 12.1563C18.0306 11.831 17.8068 11.6113 17.4669 11.6113H15.6596V10.2254L17.6863 10.2254C18.0133 10.2254 18.25 9.99718 18.25 9.67183C18.25 9.34225 18.0133 9.10563 17.6863 9.10563L15.0572 9.10563C14.5237 9.10563 14.2354 9.38873 14.2354 9.90423V14.1634C14.2354 14.6366 14.5022 14.9155 14.9626 14.9155Z"
              fill="currentColor"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3 5.75C3 4.23122 4.23122 3 5.75 3L18.25 3C19.7688 3 21 4.23122 21 5.75L21 18.25C21 19.7688 19.7688 21 18.25 21L5.75 21C4.23122 21 3 19.7688 3 18.25L3 5.75ZM5.75 4.5C5.05964 4.5 4.5 5.05964 4.5 5.75L4.5 18.25C4.5 18.9404 5.05964 19.5 5.75 19.5L18.25 19.5C18.9404 19.5 19.5 18.9404 19.5 18.25L19.5 5.75C19.5 5.05964 18.9404 4.5 18.25 4.5L5.75 4.5Z"
              fill="currentColor"
            />
          </svg>

          <BaseText
            type="label"
            size="sm"
            class="text-text-muted"
          >
            GIF
          </BaseText>
        </ModularDetailsToggleOption>
      </div>
    </BaseCard>
  </div>
</template>

<script>
import ImageIcon from '../../../components/globals/Icons/ImageIcon.vue'
import VideoIcon from '../../../components/globals/Icons/VideoIcon.vue'
import ModularDetailsSectionHeader from './ModularDetailsSectionHeader.vue'
import ModularDetailsToggleOption from './ModularDetailsToggleOption.vue'

export default {
  name: 'Format',
  components: {
    ImageIcon,
    ModularDetailsSectionHeader,
    ModularDetailsToggleOption,
    VideoIcon
  },
  props: {
    value: {
      type: String,
      default: () => null
    },
    index: {
      type: Number,
      default: () => null
    },
    expanded: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      selectedFormat: null,
      shared: false
    }
  },
  computed: {
  },
  mounted () {
    this.selectedFormat = this.value
  },
  methods: {
    getContainerClasses (section) {
      if (this.selectedFormat === section) {
        return this.shared ? 'cursor-default text-gray-700 hover:border-gray-300' : 'border-green-600 bg-green-100 text-green-600 cursor-pointer'
      }

      return 'text-gray-700 hover:border-gray-500 cursor-pointer'
    },
    toggleSelectedFormat (format) {
      if (this.shared) return
      if (this.selectedFormat === format) {
        this.selectedFormat = null
      } else {
        this.selectedFormat = format
      }

      this.$emit('update', this.index, this.selectedFormat)
    }
  }
}
</script>

<style scoped lang="css">
.show-on-hover {
  display: none
}

.animate-on-hover:hover .show-on-hover {
  display: block
}

.animate-on-hover:hover .hide-on-hover {
  display: none
}
</style>
